import { render, staticRenderFns } from "./Servicos.vue?vue&type=template&id=42a4caa3"
import script from "./Servicos.vue?vue&type=script&lang=ts"
export * from "./Servicos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports